export const siteConfig = {
  name: "Roha Jewellery",
  url: "https://rohajewellery.com",
  title: "Roha Jewellery | Ethiopian Gemstones &  Jewellery",
  description:
    "Roha Jewellery is Ethiopia’s premium gemstone jewellery brand for opal rings, emerald rings, ruby jewellery, sapphire jewellery, gold and silver jewellery, and bespoke gemstone collections designed for international buyers and luxury jewellery searches.",
  defaultKeywords:
    "Roha Jewellery, Ethiopian jewellery, gemstone ring, opal ring, emerald ring, ruby ring, sapphire ring, gold ring, silver ring, Malaysian jewellery, gemstone jewellery Ethiopia, luxury jewellery shop, custom jewellery Ethiopia, handmade gemstone ring, Ethiopian opal jewellery, emerald jewellery, gold jewellery, silver jewellery, jewellery ring",
  phones: ["+251 910 387 575", "+251 923 160 323"],
  email: "info@rohajewellery.com",
  address: "Bole Dembel City Center GFS013, Addis Ababa, Ethiopia",
  hours: "Mon - Sat, 9:00 AM - 7:00 PM",
  primaryLocation: "Addis Ababa Bole Dembel City Center GFS013, Ethiopia",
  socialImage: "https://rohajewellery.com/og-image.jpg",
  logo: "https://rohajewellery.com/logo.png",
  icon: "https://rohajewellery.com/favicon.png",
};

const fallbackApiBaseUrl =
  process.env.NODE_ENV === "development"
    ? "http://localhost:7000"
    : "https://api.rohajewellery.com";

const normalizeApiBaseUrl = (value) => {
  const raw = String(value || "").trim();

  if (!raw) return fallbackApiBaseUrl;

  // Ignore accidental Windows drive paths like Z:\...
  if (/^[a-zA-Z]:[\\/]/.test(raw) || /^[a-zA-Z]:$/.test(raw)) {
    return fallbackApiBaseUrl;
  }

  try {
    const normalized = raw.startsWith("http://") || raw.startsWith("https://")
      ? raw
      : `http://${raw.replace(/^\/+/, "")}`;

    return new URL(normalized).toString().replace(/\/$/, "");
  } catch (_error) {
    return fallbackApiBaseUrl;
  }
};

export const apiBaseUrl = normalizeApiBaseUrl(process.env.REACT_APP_BACKEND_URL);

export const getApiUrl = (path = "") =>
  `${apiBaseUrl}${path.startsWith("/") ? path : `/${path}`}`;

export const getMediaUrl = (url) => {
  const fallbackImage = "/image.jpg";
  if (!url) return fallbackImage;

  const cleanUrl = String(url).trim().replace(/\\/g, "/");

  if (!cleanUrl) return fallbackImage;

  if (cleanUrl.startsWith("data:") || cleanUrl.startsWith("blob:")) {
    return cleanUrl;
  }

  // Stored local filesystem path: keep only the filename and serve from uploads.
  if (/^[a-zA-Z]:\//.test(cleanUrl)) {
    const parts = cleanUrl.split("/");
    const fileName = parts[parts.length - 1];
    return `${apiBaseUrl}/api/uploads/products/${fileName}`;
  }

  // already full URL
  if (cleanUrl.startsWith("http://") || cleanUrl.startsWith("https://")) {
    return cleanUrl;
  }

  // backend route already includes the api uploads prefix
  if (cleanUrl.startsWith("/api/uploads/")) {
    return `${apiBaseUrl}${cleanUrl}`;
  }

  // backend may return api/uploads/... without a leading slash
  if (cleanUrl.startsWith("api/uploads/")) {
    return `${apiBaseUrl}/${cleanUrl}`;
  }

  // backend may return uploads/... paths directly
  if (cleanUrl.startsWith("/uploads/")) {
    return `${apiBaseUrl}/api${cleanUrl}`;
  }

  if (cleanUrl.startsWith("uploads/")) {
    return `${apiBaseUrl}/api/${cleanUrl}`;
  }

  // if the stored value already includes products/, keep it
  if (cleanUrl.startsWith("/products/")) {
    return `${apiBaseUrl}/api/uploads${cleanUrl}`;
  }

  if (cleanUrl.startsWith("products/")) {
    return `${apiBaseUrl}/api/uploads/${cleanUrl}`;
  }

  // filename only
  return `${apiBaseUrl}/api/uploads/products/${cleanUrl.replace(/^\/+/, "")}`;
};

const normalizePhoneForWhatsapp = (phone) => {
  if (!phone) return null;
  return String(phone).replace(/[^0-9]/g, "");
};

export const getWhatsappUrl = (text = "") => {
  const rawPhone = Array.isArray(siteConfig.phones) ? siteConfig.phones[0] : siteConfig.phones;
  const phone = normalizePhoneForWhatsapp(rawPhone);
  if (!phone) return "";
  const query = text ? `?text=${encodeURIComponent(text)}` : "";
  return `https://wa.me/${phone}${query}`;
};

export const currencyFormatter = new Intl.NumberFormat("en-ET", {
  style: "currency",
  currency: "ETB",
  maximumFractionDigits: 0,
});
